import { render, staticRenderFns } from "./CalendarEventHandlerUpdate.vue?vue&type=template&id=4028b697&"
import script from "./CalendarEventHandlerUpdate.vue?vue&type=script&lang=js&"
export * from "./CalendarEventHandlerUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEventHandlerUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports